(function () {
  'use strict';

  function todayDateKey() {
    var d = new Date();
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return y + '-' + String(m).padStart(2, '0') + '-' + String(day).padStart(2, '0');
  }

  function normToken(val) {
    return String(val == null ? '' : val)
      .trim()
      .toLowerCase();
  }

  function normCityKey(val) {
    return normToken(val).replace(/[^a-z0-9]/g, '');
  }

  function citiesLooselyMatch(a, b) {
    a = normCityKey(a);
    b = normCityKey(b);
    if (!a || !b) return false;
    if (a === b) return true;
    var prefixLen = Math.min(a.length, b.length, 5);
    if (prefixLen >= 5 && a.slice(0, prefixLen) === b.slice(0, prefixLen)) return true;
    if (a.length >= 4 && b.length >= 4 && (a.indexOf(b) >= 0 || b.indexOf(a) >= 0)) return true;
    return false;
  }

  function extractNumericRef(val) {
    var s = String(val == null ? '' : val).trim();
    if (!s) return '';
    var gid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (gid) return gid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function rowMatchesCard(ev, card) {
    var productHandle = normToken(card.getAttribute('data-elfw-product-handle'));
    if (!productHandle || normToken(ev.product_handle) !== productHandle) return false;

    var token = normToken(card.getAttribute('data-elfw-venue-token'));
    var cityName = normToken(card.getAttribute('data-elfw-city-name'));
    var venueHandle = normToken(ev.venue_handle);
    var venueRef = extractNumericRef(ev.venue_ref_id);
    var venueName = normToken(ev.venue_name);
    var evCity = normToken(ev.city);

    if (token) {
      if (venueHandle === token || venueRef === token || venueName === token) return true;
    }
    if (cityName) {
      if (citiesLooselyMatch(cityName, evCity)) return true;
      if (citiesLooselyMatch(cityName, venueName)) return true;
      if (venueName && (venueName.indexOf(cityName) >= 0 || cityName.indexOf(venueName) >= 0)) return true;
    }
    return false;
  }

  function findBestIndexRow(events, card, today) {
    var best = null;
    var bestDate = '';
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      if (!ev || !rowMatchesCard(ev, card)) continue;
      var status = normToken(ev.status);
      if (status !== 'active' && status !== 'sold_out') continue;
      var dk = String(ev.date_key || '').trim();
      if (!dk || dk < today) continue;
      if (!best || dk < bestDate) {
        best = ev;
        bestDate = dk;
      }
    }
    return best;
  }

  function findAnyIndexRow(events, card) {
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      if (!ev || !rowMatchesCard(ev, card)) continue;
      if (!extractNumericRef(ev.venue_ref_id)) continue;
      return ev;
    }
    return null;
  }

  function buildCardBookingHref(card, row) {
    var base = String(card.getAttribute('data-elfw-product-url') || '').trim();
    if (!base) {
      var handle = String(card.getAttribute('data-elfw-product-handle') || '').trim();
      if (!handle) return '';
      base = '/products/' + encodeURIComponent(handle);
    }
    var venueId = extractNumericRef(row && row.venue_ref_id);
    if (!venueId) {
      var preset = extractNumericRef(card.getAttribute('data-elfw-venue-token'));
      if (!preset) return base;
      venueId = preset;
    }
    var href = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'venue=' + encodeURIComponent(venueId);
    var eventId = extractNumericRef(row && row.event_id);
    if (eventId) href += '&event_id=' + encodeURIComponent(eventId);
    return href;
  }

  function applyCardBookingLinks(cards, events, catalog) {
    var today = todayDateKey();
    cards.forEach(function (card) {
      var presetVenue = extractNumericRef(card.getAttribute('data-elfw-venue-token'));
      var row = findBestIndexRow(events, card, today) || findAnyIndexRow(events, card);
      if (!row) {
        var catalogVenue = findCatalogVenueForCard(catalog, card);
        if (catalogVenue) row = { venue_ref_id: catalogVenue.venue_ref_id };
      }
      var href = '';
      if (row) {
        href = buildCardBookingHref(card, row);
        var venueId = extractNumericRef(row.venue_ref_id);
        if (venueId) card.setAttribute('data-elfw-venue-token', venueId);
      } else if (presetVenue) {
        href = buildCardBookingHref(card, { venue_ref_id: presetVenue });
      }
      if (!href) return;
      card.querySelectorAll('a.elfw__card-link, a.elfw__card-cta').forEach(function (anchor) {
        anchor.href = href;
      });
    });
  }

  function applyVenueCardImages(cards, catalog) {
    if (!cards || !cards.length || !catalog || !catalog.length) return;
    cards.forEach(function (card) {
      var media = card.querySelector('.elfw__card-media');
      if (!media) return;
      // Liquid already painted custom_image / venue_image / product media — do not swap (flash + override).
      if (media.querySelector('img')) return;

      var venue = findCatalogVenueForCard(catalog, card);
      var url = venue && venue.venue_image ? String(venue.venue_image).trim() : '';
      if (!url) return;

      var title = String(((card.querySelector('.elfw__card-title') || {}).textContent || '')).trim();
      media.innerHTML = '';
      var img = document.createElement('img');
      img.src = url;
      img.alt = title;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 400;
      img.height = 400;
      media.appendChild(img);
    });
  }

  function eventMatchesCard(ev, card) {
    return rowMatchesCard(ev, card);
  }

  function nearestEventSortKey(events, card, today) {
    var best = '';
    for (var i = 0; i < events.length; i++) {
      var ev = events[i];
      if (!ev || !eventMatchesCard(ev, card)) continue;
      var status = normToken(ev.status);
      if (status !== 'active' && status !== 'sold_out') continue;
      var dk = String(ev.date_key || '').trim();
      if (!dk || dk < today) continue;
      if (!best || dk < best) best = dk;
    }
    return best || '9999-12-31';
  }

  function cityGroupKey(card) {
    if (!card) return '';
    var cityName = normToken(card.getAttribute('data-elfw-city-name'));
    if (cityName) return cityName;
    var venueToken = normToken(card.getAttribute('data-elfw-venue-token'));
    if (venueToken) return venueToken;
    var title = normToken(((card.querySelector('.elfw__card-title') || {}).textContent || ''));
    return title || '__ungrouped__';
  }

  function groupCardsByCity(cards) {
    var groups = [];
    var indexByKey = Object.create(null);
    cards.forEach(function (card) {
      var key = cityGroupKey(card);
      if (indexByKey[key] == null) {
        indexByKey[key] = groups.length;
        groups.push({
          key: key,
          cards: []
        });
      }
      groups[indexByKey[key]].cards.push(card);
    });
    return groups;
  }

  function buildCityPages(groups, pageSize) {
    var pages = [];
    var current = [];
    var currentCount = 0;
    groups.forEach(function (group) {
      var groupCount = group.cards.length;
      if (current.length && currentCount + groupCount > pageSize) {
        pages.push(current);
        current = [];
        currentCount = 0;
      }
      current.push(group);
      currentCount += groupCount;
    });
    if (current.length) pages.push(current);
    if (!pages.length) pages.push([]);
    return pages;
  }

  function readVenueCatalog(sectionId) {
    var el = document.getElementById('WorkshopVenueCatalog-' + sectionId);
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function findCatalogVenueForCard(catalog, card) {
    if (!catalog || !catalog.length || !card) return null;

    var preset = extractNumericRef(card.getAttribute('data-elfw-venue-token'));
    if (preset) {
      for (var pi = 0; pi < catalog.length; pi++) {
        var presetRow = catalog[pi];
        if (!presetRow) continue;
        if (extractNumericRef(presetRow.venue_ref_id) === preset) return presetRow;
      }
    }

    var cityName = normToken(card.getAttribute('data-elfw-city-name'));
    if (!cityName) return null;

    for (var i = 0; i < catalog.length; i++) {
      var row = catalog[i];
      if (!row) continue;
      var venueName = normToken(row.venue_name);
      var venueHandle = normToken(row.venue_handle);
      if (citiesLooselyMatch(cityName, venueName)) return row;
      if (venueName && (venueName.indexOf(cityName) >= 0 || cityName.indexOf(venueName) >= 0)) return row;
      if (venueHandle && venueHandle.indexOf(cityName) >= 0) return row;
    }
    return null;
  }

  function readEventIndex(sectionId) {
    var el = document.getElementById('WorkshopVenueWorkshopIndex-' + sectionId);
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function renderPagination(nav, totalPages, currentPage, onSelect) {
    if (!nav) return;
    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = '';
      return;
    }

    nav.hidden = false;
    var html = '<div class="elfw__pagination-inner" role="navigation" aria-label="Workshop pages">';
    for (var p = 1; p <= totalPages; p++) {
      var active = p === currentPage;
      html +=
        '<button type="button" class="elfw__page-btn' +
        (active ? ' is-active' : '') +
        '" data-elfw-page="' +
        p +
        '"' +
        (active ? ' aria-current="page"' : '') +
        '>' +
        p +
        '</button>';
    }
    html += '</div>';
    nav.innerHTML = html;

    nav.querySelectorAll('[data-elfw-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var page = Number(btn.getAttribute('data-elfw-page')) || 1;
        onSelect(page);
      });
    });
  }

  function readPageSize(root) {
    var mobileMq = window.matchMedia('(max-width: 749px)');
    if (mobileMq.matches) {
      return Number.MAX_SAFE_INTEGER;
    }
    var cols = Math.max(1, Number(root.getAttribute('data-elfw-cols')) || 4);
    var rows = Math.max(1, Number(root.getAttribute('data-elfw-rows')) || 4);
    return cols * rows;
  }

  function initSection(sectionEl) {
    var root = sectionEl.querySelector('[data-elfw-root]');
    if (!root || root.__elfwInit) return;
    root.__elfwInit = true;

    var sectionId = root.getAttribute('data-elfw-section-id') || '';
    var pageSize = readPageSize(root);

    var grid = root.querySelector('[data-elfw-grid]');
    var pagination = root.querySelector('[data-elfw-pagination]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.elfw__card'));
    if (!cards.length) return;

    var events = readEventIndex(sectionId);
    var catalog = readVenueCatalog(sectionId);
    var today = todayDateKey();

    applyCardBookingLinks(cards, events, catalog);
    applyVenueCardImages(cards, catalog);

    cards.sort(function (a, b) {
      var aKey = nearestEventSortKey(events, a, today);
      var bKey = nearestEventSortKey(events, b, today);
      if (aKey !== bKey) return aKey.localeCompare(bKey);
      var aTitle = (a.querySelector('.elfw__card-title') || {}).textContent || '';
      var bTitle = (b.querySelector('.elfw__card-title') || {}).textContent || '';
      return aTitle.localeCompare(bTitle);
    });

    cards.forEach(function (card) {
      grid.appendChild(card);
    });

    var cityGroups = groupCardsByCity(cards);
    var currentPage = 1;
    var pagedCityGroups = [];
    var totalPages = 1;

    function rebuildPages() {
      pageSize = readPageSize(root);
      pagedCityGroups = buildCityPages(cityGroups, pageSize);
      totalPages = Math.max(1, pagedCityGroups.length);
      if (currentPage > totalPages) currentPage = totalPages;
    }

    function showPage(page) {
      currentPage = Math.min(Math.max(1, page), totalPages);
      var visibleSet = new Set();
      (pagedCityGroups[currentPage - 1] || []).forEach(function (group) {
        group.cards.forEach(function (card) {
          visibleSet.add(card);
        });
      });
      cards.forEach(function (card) {
        card.hidden = !visibleSet.has(card);
      });
      renderPagination(pagination, totalPages, currentPage, showPage);
    }

    rebuildPages();
    showPage(1);

    var mobileMq = window.matchMedia('(max-width: 749px)');
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', function () {
        rebuildPages();
        showPage(currentPage);
      });
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(function () {
        rebuildPages();
        showPage(currentPage);
      });
    }
  }

  function boot() {
    document.querySelectorAll('.section-event-locations-featured-workshops').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('section-event-locations-featured-workshops')) {
      var root = el.querySelector('[data-elfw-root]');
      if (root) root.__elfwInit = false;
      initSection(el);
    }
  });
})();
